<app-shared [type]="'inventaire'" [status]="'Crée'"></app-shared>
